module.exports = __webpack_public_path__ + "img/xp-old.4999f8db.svg";